import { render, staticRenderFns } from "./ManageOrders.vue?vue&type=template&id=303852b6&scoped=true&"
import script from "./ManageOrders.vue?vue&type=script&lang=js&"
export * from "./ManageOrders.vue?vue&type=script&lang=js&"
import style0 from "./ManageOrders.vue?vue&type=style&index=0&id=303852b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303852b6",
  null
  
)

export default component.exports